import { Box, Button, Pagination, Stack, Typography } from "@mui/material";
import useClients from "hooks/useClients";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import useTransactionGroups from "hooks/useTransactionGroups";
import TransactionGroupTable from "./TransactionGroupTable";
import { useQuery } from "hooks/useQuery";
import { useState } from "react";
import { PageActions, PageBreadcrumbs, PageTitle } from "pages/Layouts/components/PageTitleContainer";

export function TransactionGroupIndex() {
  const { client } = useClients();
  const { earnings, transactionGroups, totalPages, deleteTransactionGroup } = useTransactionGroups();
  const params = useParams();
  const query = useQuery();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [searchQuery] = useState("");
  const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
    query.delete("page[number]");
    query.delete("q");
    query.append("q", searchQuery);
    if (value != 1) {
      query.append("page[number]", String(value));
    }

    navigate(`?${query.toString()}`);
  };

  return (
    <Box>
      <PageBreadcrumbs
        links={[
          { label: "Finance", path: "/finance/pickups" },
          { label: "Clients", path: "/finance/clients" },
          { label: client ? client?.name : "", path: client ? `/finance/clients/${client?.uuid}` : undefined },
        ]}
      />
      <PageTitle>{client?.name}</PageTitle>

      <PageActions>
        <Button
          to={`/finance/clients/${params.uuid}/transaction_groups/new`}
          component={RouterLink}
          startIcon={<AddIcon />}
          variant="contained"
        >
          Add Transaction
        </Button>
      </PageActions>

      <Box
        sx={{
          background: "#ffffff",
          borderRadius: 1,
          border: (theme) => `1px solid ${theme.palette.divider}`,
          p: 1,
          my: 2,
        }}
      >
        <Stack p={2}>
          <Typography fontSize={35} fontWeight={600} component="div">
            ${Number(earnings) / 100}
          </Typography>
          <Typography>Total Earnings</Typography>
        </Stack>
      </Box>

      <Box
        sx={{
          background: "#ffffff",
          borderRadius: 1,
          border: (theme) => `1px solid ${theme.palette.divider}`,
          p: 2,
        }}
      >
        <Box>
          {
            <TransactionGroupTable
              transactions={transactionGroups || []}
              client={client || undefined}
              deleteTransactionGroup={deleteTransactionGroup}
            />
          }
        </Box>

        {totalPages > 1 && (
          <Box textAlign="center" mt={2} sx={{ display: "flex", justifyContent: "end" }}>
            <Pagination count={totalPages} page={page} onChange={handlePageChange} />
          </Box>
        )}
      </Box>
    </Box>
  );
}
